// extracted by mini-css-extract-plugin
export default {"layoutedContentGrid":"pdp-layoutedContentGrid","gridContent":"pdp-gridContent"};